
import { Injectable } from '@angular/core';

import {
    ExportedClass as UserService
} from './UserService';

import { SERVICE,TIME } from './NeurConstants';

@Injectable()
class CollectionService {

    private collections;

    constructor(private userService:UserService) {

    }
    
    public set(place){
        let placeKeyInfo = {
                _id: place._id,
                name:place.name
        }
        this.collections.set(place._id,placeKeyInfo);
        this.save();
    }
    
    public remove(place_id) {
            this.collections.delete(place_id);
            this.save();
    }
    
    public has(place_id){
        return this.collections.has(place_id);
    }

    public retreive(){
        // from storage 
        this.collections = this.userService.user_info.collections;
        if (!this.collections){
            this.collections = new Map();
        }
    }
    
    private async save(){
        this.userService.user_info.collections = this.collections;
        this.userService.save_user_infobase();
    }
}

/*
    Service class should be exported as ExportedClass
*/
export { CollectionService as ExportedClass };
